import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';

const Ticket = () => {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route exact path={`${match.url}`} component={lazy(() => import('./Ticket'))} />
        <Route path={`${match.url}/edit/:id`} component={lazy(() => import('./TicketEdit'))} />

        <Route component={lazy(() => import('../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default Ticket;
